goog.provide('el8.appchart.dialog.order.addLabOrderSet');

goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.template.appchart.dialog.order.addLabOrderSet');
goog.require('el8.util.amplitude.helpers');


el8.appchart.dialog.order.addLabOrderSet = (function() {

    var _saveCallbackFn = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Save As Lab Order Set',
        modal: true,
        autoHeight: true,
        width: 400,
        contentFn: el8.template.appchart.dialog.order.addLabOrderSet.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'orderSetName',
                selector: ':input[name="orderSetName"]'
            }
        ]
    });
    form.addSaveButton(function(_form) {

        el8.util.amplitude.logEvent('save as lab order set', {'action':'Save'});

        var validated = that._validate();
        if (!validated.result) {
            el8.uiwidget.alert(validated.msg);
            return;
        }

        var name = _form.getVal('orderSetName');

        /* Check if name already exists before POSTing */
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('labOrderSets'),
            data: { name: name },
            success: function(data) {
                if (data && data.id) {
                    // data.id represents the ID of an existing order set with this name
                    var confirmMsg = 'An order set named "' + name +
                        '" already exists. Do you want to replace the existing order set?';
                    el8.uiwidget.confirm(confirmMsg,
                        function() {
                            if (_saveCallbackFn) { _saveCallbackFn(name, data.id); }
                            that.hide();
                        },
                        function() { form.initFocus(); }
                    );
                } else {
                    if (_saveCallbackFn) { _saveCallbackFn(name); }
                    that.hide();
                }
            }
        });
    }, true);
    form.addDiscardButton(function() {
        that.hide();
        el8.util.amplitude.logEvent('save as lab order set', {'action':'Discard'});
    }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        _saveCallbackFn = spec.saveCallbackFn || null;
        super_show.call(that);
        if (spec.name) {
            form.setVal('orderSetName', spec.name);
        }
    };

    that._validate = function() {
        if (!form.getVal('orderSetName')) {
            return {result: false, msg: 'Please enter a name for the order set.'};
        }
        return {result: true};
    };

    return that;

})();

